import { baseInput } from './inputs/baseInput'

export default {
  ...baseInput,
  boxShadow: 2,
  backgroundColor: 'bgs.1',
  lineHeight: 1.8,
  overflow: 'hidden',
  zIndex: 1
}
